import React from 'react';
import { WithIcon } from './WithIcon';

export const IconFlipboard = WithIcon(
  'Flipboard',
  '0 0 500 500',
  <path d="M0,0V500H500V0ZM400,200H300V300H200V400H100V100H400Z" />
);
